import { createSelector } from 'reselect';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import { getDataSetEntities } from '../entities';

const getDatasetFromProps = (_, ownProps) => {
  const { data, cardData } = ownProps;
  return cardData ? cardData : data ? data : null;
};

export const getFirstParentForDataset = createSelector(
  [getDatasetFromProps, getDataSetEntities],
  (thisDataset, allDataSets) => {
    let parentDataSetId = null;
    let parentDataSet = null;
    if (thisDataset) {
      if (has(thisDataset, 'parent_data_sets') && !isEmpty(thisDataset.parent_data_sets)) {
        parentDataSetId = thisDataset.parent_data_sets[0].id;
        parentDataSet = thisDataset.parent_data_sets[0];
      } else if (has(thisDataset, 'parent_data_set_id') && !isNil(thisDataset.parent_data_set_id)) {
        parentDataSetId = thisDataset.parent_data_set_id;
      }
    }
    //if entities has this Nexset best use that instead of the one in this response
    if (parentDataSetId && has(allDataSets, `${parentDataSetId}`)) {
      parentDataSet = allDataSets[`${parentDataSetId}`];
    }

    return parentDataSet;
  },
);
